import {safeToFixed} from './helper';

const getCurrencySymbol = (): string => '฿';

const formatPrice = (value = 0.0): string => {
  const defaultOptions = {
    significantDigits: 2,
    thousandsSeparator: ',',
    decimalSeparator: '.'
  };

  const price = safeToFixed(value ?? 0.0, defaultOptions.significantDigits);

  const [currency, decimal] = price?.split('.') ?? [];
  return `${currency.replace(/\B(?=(\d{3})+(?!\d))/g, defaultOptions.thousandsSeparator)}${
    defaultOptions.decimalSeparator
  }${decimal}`;
};

const formatPriceWithCurrency = (value: number, priceUnit?: string): string => {
  return `${formatPrice(value)} ${priceUnit ? getCurrencySymbol() : ''}`;
};

const formatPriceWithCurrencyOrderDetails = (value: number, priceUnit?: string): string => {
  if (!value) {
    return '';
  }
  return `${formatPrice(value)} ${priceUnit ? getCurrencySymbol() : ''}`;
};

const addLeadingZeros = (num: number, totalLength: number) => {
  return String(num).padStart(totalLength, '0');
};

const formatPriceWithoutDecimal = (n: number): string => formatPrice(n).split('.')[0];

export {
  getCurrencySymbol,
  formatPrice,
  formatPriceWithCurrency,
  formatPriceWithCurrencyOrderDetails,
  addLeadingZeros,
  formatPriceWithoutDecimal
};
